<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>post_add</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>Alta de Denuncia</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row v-if="!selectedPersona" dense>
            <v-col>
              <span>Seleccione a una Persona</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="!selectedPersona">
            <v-col cols="12">
              <app-busqueda-personas
                :personaSeleccionada="setPersona"
              ></app-busqueda-personas>
            </v-col>
          </v-row>

          <v-row v-if="selectedPersona">
            <v-col>
              <span>Cliente que realiza la Denuncia</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="selectedPersona">
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.cui"
                label="CUI(L/T) "
                key="cuil"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.nombreCompleto"
                label="Nombre"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="warning" small text @click="limpiar"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>

                    <span v-if="selectedPersona">
                        <v-row>
                            <v-col cols="4">
                                <v-autocomplete
                                v-model="model.creditoId"
                                :items="creditos"
                                autocomplete="disabled"
                                item-text="numero"
                                item-value="creditoId"
                                label="Credito"
                                placeholder="Seleccione una"
                                :menu-props="{ minWidth: '400' }"
                                @change="setEstadoCredito(model.creditoId), setEmpresa(model.creditoId)"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete
                                v-model="model.empresaId"
                                :items="empresas"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="Empresa Denunciada"
                                placeholder="Seleccione una"
                                :menu-props="{ minWidth: '400' }"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                v-model="empresaCredito"
                                autocomplete="disabled"
                                label="Empresa otorgante del crédito"
                                :disabled="true"
                                :menu-props="{ minWidth: '400' }"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col cols="4">
                                <v-autocomplete
                                v-model="model.motivoDenunciaId"
                                :items="motivosDenuncia"
                                autocomplete="disabled"
                                item-text="descripcion"
                                item-value="id"
                                label="Motivo Denuncia"
                                placeholder="Seleccione una"
                                :menu-props="{ minWidth: '400' }"
                                ></v-autocomplete>                        
                            </v-col>  
                            <v-col cols="4">
                                <v-autocomplete
                                v-model="model.tipoDenunciaId"
                                :items="tipoDenuncia"
                                autocomplete="disabled"
                                item-text="descripcion"
                                item-value="id"
                                label="Tipo Denuncia"
                                placeholder="Seleccione uno"
                                :menu-props="{ minWidth: '400' }"
                                ></v-autocomplete>
                            </v-col> 
                            <v-col cols="4">
                                <v-autocomplete
                                v-model="model.tipoEstadoCreditoDenunciaId"
                                :items="tipoEstadoCreditoDenuncia"
                                autocomplete="disabled"
                                item-text="descripcion"
                                item-value="id"
                                label="Estado Credito con Denuncia"
                                placeholder="Seleccione uno"
                                :menu-props="{ minWidth: '400' }"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-autocomplete
                                v-model="model.estadoDebitoId"
                                :items="tiposEstadoDebito"
                                autocomplete="disabled"
                                item-text="descripcion"
                                item-value="id"
                                label="Estado Debito"
                                placeholder="Seleccione uno"
                                :menu-props="{ minWidth: '400' }"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete
                                v-model="model.provinciaId"
                                :items="provincias"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="Provincia"
                                placeholder="Seleccione una"
                                :menu-props="{ minWidth: '400' }"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="4">
                                <div>
                                    <v-text-field
                                    type="decimal"
                                    v-model="model.saldo"
                                    label="Saldo"
                                    @change="parseInput(model.saldo, 'saldo')"
                                    />
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <div>
                                    <v-text-field
                                    type="decimal"
                                    v-model="model.capital"
                                    label="Capital"
                                    @change="parseInput(model.capital, 'capital')"
                                    />
                                </div>
                            </v-col>

                            <v-col cols="4">
                                <div>
                                  <v-autocomplete
                                v-model="model.origenId"
                                :items="tiposOrigen"
                                autocomplete="disabled"
                                item-text="descripcion"
                                item-value="id"
                                label="Origen"
                                placeholder="Seleccione uno"
                                :menu-props="{ minWidth: '400' }"
                                ></v-autocomplete>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="model.fechaRecepcion"
                                        label="fechaRecepcion"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="model.fechaRecepcion"
                                    @input="menu1 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="model.fechaAudiencia"
                                        label="fechaAudiencia"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="model.fechaAudiencia"
                                    @input="menu2 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    v-model="menu3"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="model.fechaContestacion"
                                        label="fechaContestacion"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="model.fechaContestacion"
                                    @input="menu3 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>    
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="model.comentarios"
                                    class="mx-2"
                                    label="Comentarios Adicionales"
                                    prepend-icon="comment"
                                    clearable
                                    auto-grow
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="model.motivoResumido"
                                    class="mx-2"
                                    label="Resumen del Motivo de la Denuncia"
                                    prepend-icon="comment"
                                    clearable
                                    auto-grow
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </span>
                    
                </v-container>
            </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="altaReclamo"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
//import Vue from 'vue'
import { http } from '@/axios';
//import { addDays, format } from 'date-fns'
//import {Decimal} from 'decimal.js';

import {
  //mapState,
  mapGetters,
  mapMutations,
  //mapActions
} from 'vuex';

export default {
    data: () => ({
            saving:false,
            validando: false,
            selectedPersona: null,
            model: {empresaId:0,
                    personaId:'',
                    creditoId:'',
                    motivoDenunciaId:0,
                    tipoDenunciaId:0,
                    estadoCreditoId:0,
                    tipoEstadoCreditoDenunciaId:0,
                    comentarios:'',
                    provinciaId:0,
                    suspendeDebito:false,
                    fechaRecepcion:'',
                    fechaAudiencia:'',
                    fechaContestacion:'',
                    saldo: 0.0,
                    capital: 0.0,
                    motivoResumido:'',
                    estadoDebitoId:0,
                    origenId:0
                    },
            numeroReclamo:0,
            empresas:[],
            creditos:[],
            tipoEstadosCredito:[],
            motivosDenuncia:[],
            tipoDenuncia:[],
            tipoEstadoCreditoDenuncia:[],
            provincias:[],
            totalItems:0,
            empresaCredito:0,
            tiposEstadoDebito:[],
            tiposOrigen:[],
        }
    ),
    props:{
        modo:{type:String}
    },
    created(){
        this.loadEmpresas();
        this.loadtipoDenuncia();
        this.loadMotivosDenuncia();
        this.loadEstadoCreditoDenuncia();
        this.loadProvincias();
        this.loadEstadoCredito();
        this.loadEstadosDebito();
        this.loadTipoOrigen();
    },
    computed: {
        ...mapGetters(['getActionFromLink','user']),
        listCreditosActivos: function (){
            if(!this.listDeudas || this.listDeudas.length == 0) return [];
            let lista =this.listDeudas.filter(i=>i.tipo == 'Credito' || i.tipo == 'Acuerdo')

      return lista;
    },
  },
  watch: {
    seAsociaACredito: function() {
      this.listCargosAAplicar = [];
      this.importeCargoAAgregar = 0;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    limpiar: function() {
      this.selectedPersona = null;
      this.creditoSeleccionadoId = null;
      this.creditoSeleccionadoNumero = 0;
      this.cuotaSeleccionada = null;
      this.listCargosAAplicar = [];
    },
    async setPersona(persona) {
      this.selectedPersona = persona;
      this.model.personaId = persona.personaId;
      await this.loadCreditos();
    },
    async altaReclamo() {
      if (!this.validarAlta()) return;

      var params = {};
      params.empresaId = this.model.empresaId;
      params.personaId = this.model.personaId;
      params.creditoId = this.model.creditoId;
      params.saldoCredito = this.model.saldo;
      params.motivoId = this.model.motivoDenunciaId;
      params.tipoId = this.model.tipoDenunciaId;
      params.estadoCreditoId = this.model.estadoCreditoId;
      params.estadoCreditoConDenunciaId = this.model.tipoEstadoCreditoDenunciaId;
      params.suspendeDebito = this.model.suspendeDebito;
      params.provinciaId = this.model.provinciaId;
      params.comentarios = this.model.comentarios;
      params.fechaRecepcion = this.model.fechaRecepcion;
      params.fechaAudiencia = this.model.fechaAudiencia;
      params.fechaContestacion = this.model.fechaContestacion;
      params.motivoResumido = this.model.motivoResumido;
      params.capital = this.model.capital;
      params.estadoDebitoId = this.model.estadoDebitoId;
      params.origenId = this.model.origenId; 
      try {
        this.saving = true;
        var result = await http.post(
          'gestion/creardenuncia',
          JSON.stringify({ denuncia: params })
        );
        this.alertSuccess(
          'Se ha generado el Alta del Denuncia ' + result.entity.numero
        );
        this.limpiar();
        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.saving = false;
    },
    validarAlta() {
      if (!this.model.personaId) {
        this.alertWarning('Debe elegir una persona.');
        return false;
      }
      if (!this.model.empresaId) {
        this.alertWarning('Debe elegir una Empresa para el Denuncia.');
        return false;
      }
      if (!this.model.creditoId) {
        this.alertWarning('Debe elegir un Canal de Denuncia.');
        return false;
      }

      if (!this.model.estadoCreditoId) {
        this.alertWarning('Debe ingresar un Estado de Credito.');
        return false;
      }

      if (!this.model.motivoDenunciaId) {
        this.alertWarning('Debe ingresar un Motivo para la Denuncia.');
        return false;
      }

      if (!this.model.tipoDenunciaId) {
        this.alertWarning('Debe ingresar un tipo para la Denuncia.');
        return false;
      }

      if (!this.model.tipoEstadoCreditoDenunciaId) {
        this.alertWarning('Debe ingresar un Estado de Credito Con Denuncia.');
        return false;
      }

      if (!this.model.provinciaId) {
        this.alertWarning('Debe ingresar una Provincia.');
        return false;
      }

      if (!this.model.comentarios) {
        this.alertWarning('Debe agregar un Comentario al Denuncia.');
        return false;
      }

      if (!this.model.fechaRecepcion) {
        this.alertWarning('Debe agregar una Fecha de Recepción.');
        return false;
      }

      if (!this.model.fechaAudiencia) {
        this.alertWarning('Debe agregar una Fecha de Audiencia.');
        return false;
      }

      if (!this.model.estadoDebitoId) {
        this.alertWarning('Debe agregar una Estado Debito.');
        return false;
      }

      return true;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list;
        this.empresas.push({ id: 3, nombre: 'EPB' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCreditos() {
      this.loading = true;
      try {
        var result = await http.get(
          'creditos/listporpersona?personaId=' + this.model.personaId
        );
        this.creditos = result.list;
        if (result.list.length > 0)
          for (let i = 0; i < result.list.length; i++) {
            this.model.capital =
              parseFloat(this.model.capital) +
              parseFloat(this.creditos[i].capital);
          }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadtipoDenuncia() {
      this.loading = true;
      try {
        var result = await http.get('tiposdenuncia');

        this.tipoDenuncia = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMotivosDenuncia() {
      this.loading = true;
      try {
        var result = await http.get('tiposmotivodenuncia');

        this.motivosDenuncia = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadosDebito() {
      this.loading = true;
      try {
        var result = await http.get('tiposdebitosdenuncia');
        this.tiposEstadoDebito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadoCreditoDenuncia() {
      this.loading = true;
      try {
        var result = await http.get('tiposcreditodenuncia');

        this.tipoEstadoCreditoDenuncia = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProvincias() {
      this.loading = true;
      try {
        var result = await http.get('provincias');

        this.provincias = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadoCredito() {
      this.loading = true;
      try {
        var result = await http.get('tipoestadocredito');
        this.tipoEstadosCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTipoOrigen() {
      this.loading = true;
      try {
        var result = await http.get('tipoOrigenDenuncia');

        this.tiposOrigen = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    setEmpresa(creditoId){
        let creditos = this.creditos
        let credito = creditos.filter(cred=>cred.creditoId==creditoId);
        
        this.model.empresaId = credito[0].empresaId
        this.empresaCredito = credito[0].empresa
    },
    setEstadoCredito(creditoId) {
      let creditos = this.creditos;
      let credito = creditos.filter((cred) => cred.creditoId == creditoId);

      let estadoId = this.tipoEstadosCredito.filter(
        (estado) => estado.descripcion == credito[0].estadoDescripcion
      );
      this.model.estadoCreditoId = estadoId[0].id;
      //añado acá el setSaldo por conveniencia
      this.model.saldo = credito[0].saldoTotal;
    },
    parseInput(i, origen) {
      let n = parseFloat(i).toFixed(2);
      if (i<=0) this.model[origen] = 0.0;
      else this.model[origen] = n;
    },
  },
};
</script>
